export const hackTheWind = {
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: 'Hack the Wind 2018',
  startDate: '2018-10-XX',
  endDate: '2018-10-XX',
  description:
    'Hack the Wind 2018 was the second edition of a hackathon hosted by InnoEnergy and Wind Europe during the Global Wind Summit. More than 20 development teams competed to build a product using machine learning to forecast wind turbine breakdowns. The competition focused on both the machine learning models and the user experience of the product.',
  location: {
    '@type': 'Place',
    name: 'Global Wind Summit',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'DE',
    },
  },
  sponsor: {
    '@type': 'Organization',
    name: 'EDPR',
  },
  organizer: [
    {
      '@type': 'Organization',
      name: 'InnoEnergy',
    },
    {
      '@type': 'Organization',
      name: 'Wind Europe',
    },
  ],
  performer: {
    '@type': 'Organization',
    name: 'Boldare Machine Learning Team',
    description:
      'A cross-functional team of machine learning developers, DevOps, frontend developers, and product designers with strong expertise in AI and agile product development. The team ranked in the top 3 at the hackathon.',
  },
  url: 'https://www.boldare.com/hack-the-wind/',
};
